import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import remarkBreaks from 'remark-breaks'

type MarkdownProps = {
  value: string
}

const remarkPlugins = [remarkGfm, remarkBreaks]

const Markdown: React.FC<MarkdownProps> = ({ value }): React.ReactElement => {
  return <ReactMarkdown remarkPlugins={remarkPlugins}>{value}</ReactMarkdown>
}

export default Markdown
